import $ from 'jquery'
import Widget from './base.js'
import { isTouchDevice } from 'tpm-utils'
import { Component } from 'preact'

/*
references
https://www.nytimes.com/interactive/2019/10/04/us/politics/president-trump-impeachment-inquiry.html
https://www.pbs.org/newshour/politics/who-has-congress-subpoenaed-in-the-impeachment-investigation
https://www.rollingstone.com/politics/politics-news/impeachment-inquiry-witnesses-guide-896181/
https://www.latimes.com/politics/story/2019-10-10/impeachment-inquiry-trump-calendar-dates-subpoena-deposition
*/

export class ImpeachmentExplainer extends Widget {
  requestSheet() {
    // ID of the Google Spreadsheet
    const spreadsheetID = '19mdT2uz_yHOSgTEIgFFrJQ0Y5y9rC2S81ddC4JfeTrM'

    // Make sure it is public or set to Anyone with link can view
    const url =
      'https://spreadsheets.google.com/feeds/list/' +
      spreadsheetID +
      '/od6/public/values?alt=json'
    $.getJSON(url, (data) => {
      this.setState({
        data: data,
      })
    })
  }

  componentWillMount() {
    this.requestSheet()
  }

  get data() {
    return this.state.data ? this.state.data.feed.entry : null
  }

  getCell(row, colName) {
    return row[`gsx$${colName}`]['$t']
  }

  get dataDocs() {
    return this.data.filter(
      (row) => this.getCell(row, 'docrequested') === 'Yes'
    )
  }

  get dataTestimony() {
    return this.data.filter(
      (row) => this.getCell(row, 'testimonyrequested') === 'Yes'
    )
  }

  renderTestimonyTable() {
    const self = this

    const statusYes = this.dataTestimony.filter((row) => {
      return self.getCell(row, 'testimonystatus') === 'Yes'
    })

    const statusNo = this.dataTestimony.filter((row) => {
      return self.getCell(row, 'testimonystatus') === 'No'
    })

    const statusPending = this.dataTestimony.filter((row) => {
      return self.getCell(row, 'testimonystatus') === 'Pending'
    })

    return (
      <div class="ImpeachmentTable">
        <div class="ImpeachmentTable__TableHeading">Testimony</div>
        <div class="ImpeachmentTable__Table">
          <div class="ImpeachmentTable__Col">
            <div class="ImpeachmentTable__ColHeading">
              Has <span class="ImpeachmentTable__Breaker" />
              Testified
            </div>
            {statusYes.map((row) => {
              return <Cell row={row} type="testimony" col="left" />
            })}
          </div>

          <div class="ImpeachmentTable__Col --center">
            <div class="ImpeachmentTable__ColHeading">
              Refused <span class="ImpeachmentTable__Breaker" />
              to Testify
            </div>
            {statusNo.map((row) => {
              return <Cell row={row} type="testimony" col="center" />
            })}
          </div>

          <div class="ImpeachmentTable__Col --right">
            <div class="ImpeachmentTable__ColHeading">
              Request <span class="ImpeachmentTable__Breaker" />
              Pending
            </div>
            {statusPending.map((row) => {
              return <Cell row={row} type="testimony" col="right" />
            })}
          </div>
        </div>
      </div>
    )
  }

  renderDocsTable() {
    const self = this

    const statusYes = this.dataDocs.filter((row) => {
      return self.getCell(row, 'docrequeststatus') === 'Yes'
    })

    const statusNo = this.dataDocs.filter((row) => {
      return self.getCell(row, 'docrequeststatus') === 'No'
    })

    const statusPending = this.dataDocs.filter((row) => {
      return self.getCell(row, 'docrequeststatus') === 'Pending'
    })

    return (
      <div class="ImpeachmentTable">
        <div class="ImpeachmentTable__TableHeading">Documents</div>
        <div class="ImpeachmentTable__Table">
          <div class="ImpeachmentTable__Col">
            <div class="ImpeachmentTable__ColHeading">
              Turned <span class="ImpeachmentTable__Breaker" />
              Over
            </div>
            {statusYes.map((row) => {
              return <Cell row={row} type="doc" col="left" />
            })}
          </div>

          <div class="ImpeachmentTable__Col --center">
            <div class="ImpeachmentTable__ColHeading">
              Not <span class="ImpeachmentTable__Breaker" />
              Turned Over
            </div>
            {statusNo.map((row) => {
              return <Cell row={row} type="doc" col="center" />
            })}
          </div>

          <div class="ImpeachmentTable__Col --right">
            <div class="ImpeachmentTable__ColHeading">
              Request <span class="ImpeachmentTable__Breaker" />
              Pending
            </div>
            {statusPending.map((row) => {
              return <Cell row={row} type="doc" col="right" />
            })}
          </div>
        </div>
      </div>
    )
  }

  renderContent() {
    if (!this.state.data) return <div>fetching data...</div>
    if (!this.data) return <div>error loading data</div>
    return [this.renderTestimonyTable(), this.renderDocsTable()]
  }
}

/*
  individual cell
*/
class Cell extends Component {
  componentWillMount() {
    this.touchDevice = isTouchDevice()
  }

  hoverToggle() {
    //only for non-touch devices
    if (this.touchDevice) return

    this.setState({
      hover: !this.state.hover,
    })
  }

  clickToggle() {
    //only for touch devices
    if (this.touchDevice) {
      this.setState({
        hover: !this.state.hover,
      })
    }
  }

  getCell(row, colName) {
    return row[`gsx$${colName}`]['$t']
  }

  get popover() {
    const { row, type } = this.props
    if (!this.state.hover) return null
    if (!type) return null

    const name = this.getCell(row, 'name')
    const title = this.getCell(row, 'title')

    let imgSrc = this.getCell(row, 'image')
    const img = imgSrc ? (
      <img class="ImpeachmentTable__PopoverImg" src={imgSrc} />
    ) : null

    let notes
    if (type === 'doc') {
      notes = this.getCell(row, 'docrequestnotes')
    }

    if (type === 'testimony') {
      notes = this.getCell(row, 'testimonynotes')
    }

    return (
      <div
        class={`ImpeachmentTable__Popover  --${this.props.col}`}
        onClick={this.clickToggle.bind(this)}
      >
        <div class="ImpeachmentTable__PopoverContent">
          {img}
          <div class="ImpeachmentTable__PopoverNameAndTitle">
            <div class="ImpeachmentTable__PopoverName">{name}</div>
            <div class="ImpeachmentTable__PopoverTitle">{title}</div>
          </div>
          <div class="ImpeachmentTable__PopoverNotes">{notes}</div>
        </div>
      </div>
    )
  }

  render() {
    const { row, type } = this.props
    return (
      <div class={`ImpeachmentTable__Cell`}>
        <div
          class="ImpeachmentTable__CellName"
          onMouseOver={this.hoverToggle.bind(this)}
          onMouseOut={this.hoverToggle.bind(this)}
          onClick={this.clickToggle.bind(this)}
        >
          {this.getCell(row, 'name')}
          {this.state.hover ? (
            <div class="ImpeachmentTable__CellTriangle" />
          ) : null}
        </div>
        {this.popover}
      </div>
    )
  }
}
